<template>
  <BaseBottomSheet ref="dialog" @close="handleForceClose">
    <AuthLogin
      v-if="componentCode === 'login'"
      :is-loading.sync="isLoading"
      :is-loading-google="isLoadingGoogle"
      :error="error"
      @open-registration="handleOpenRegistration"
      @open-code="handleOpenCode"
      @success="handleSuccessLogin"
      @google-sign-in="handleGoogleSignIn"
    />

    <AuthRegistration
      v-else-if="componentCode === 'registration'"
      :is-loading.sync="isLoading"
      :is-loading-google="isLoadingGoogle"
      :error="error"
      @open-login="handleOpenLogin"
      @open-code="handleOpenCode"
      @google-sign-in="handleGoogleSignIn"
    />

    <AuthCode
      v-else-if="componentCode === 'code'"
      :email="form.email"
      @success="handleSuccessLogin"
    />
  </BaseBottomSheet>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { isEmbeddedBrowser } from '@/utils/base'

import BaseBottomSheet from '@/components/Base/BaseBottomSheet.vue'

import AuthLogin from '@/components/Auth/AuthLogin.vue'
import AuthRegistration from '@/components/Auth/AuthRegistration.vue'
import AuthCode from '@/components/Auth/AuthCode.vue'

export default {
  name: 'TheAuth',

  components: {
    BaseBottomSheet,
    AuthLogin,
    AuthRegistration,
    AuthCode
  },

  data: () => ({
    form: {
      email: ''
    },

    componentCode: 'login',
    error: null,
    isLoading: false,
    isLoadingGoogle: false
  }),

  computed: {
    ...mapState('ui', ['ui'])
  },

  created() {
    this.componentCode = this.ui.authModal.componentCode || 'login'
  },

  methods: {
    ...mapMutations('ui', {
      setUiAuthModal: 'SET_UI_AUTH_MODAL'
    }),

    ...mapActions('auth', {
      login: 'LOGIN'
    }),

    // ...mapActions('user', {
    //   updateSectionRecords: 'UPDATE_SECTION_RECORDS'
    // }),

    handleOpenRegistration() {
      this.componentCode = 'registration'
    },

    handleOpenLogin() {
      this.componentCode = 'login'
    },

    handleOpenCode({ email }) {
      this.componentCode = 'code'
      this.form.email = email
    },

    async handleGoogleSignIn() {
      if (isEmbeddedBrowser()) {
        window.alert(this.$t('auth.googleEmbeddedBrowserAlert'))
        return
      }
      this.error = null

      try {
        this.isLoadingGoogle = true

        const googleProvider = new GoogleAuthProvider({
          prompt: 'select_account'
        })

        const result = await signInWithPopup(
          this.$firebase.auth,
          googleProvider
        )

        const idToken = await result.user.getIdToken()

        const payload = {
          idToken,
          email: result.user.email,
          name: result.user.displayName,
          photoURL: result.user.photoURL,
          providerId: result.providerId
        }

        this.$gtag.event('auth_login_submitted')

        const { isSuccess, error } = await this.login({
          payload,
          type: 'social'
        })

        if (error) {
          this.error = error
        }

        if (!isSuccess) return

        // await this.setSectionRecordsIfNeeded()

        this.$gtag.event('auth_login_success')
        this.handleSuccessLogin()
      } catch (error) {
        console.log('Google Sign-in Error:', error)
      } finally {
        this.isLoadingGoogle = false
      }
    },

    // async setSectionRecordsIfNeeded() {
    //   if (this.$route.query.sectionRecords) {
    //     const sectionRecords = JSON.parse(this.$route.query.sectionRecords)

    //     this.$router.replace({
    //       query: { ...this.$route.query, sectionRecords: undefined }
    //     })

    //     await this.updateSectionRecords(sectionRecords)
    //   }
    // },

    handleSuccessLogin() {
      if (this.ui.authModal.redirectTo) {
        this.$router.push(this.ui.authModal.redirectTo)
      } else if (this.ui.authModal.onSuccess) {
        this.ui.authModal.onSuccess()
      } else {
        this.$router.push({ name: 'hub.sections' })
      }

      this.handleClose()
    },

    handleClose() {
      this.$refs.dialog.handleClose()
    },

    handleForceClose() {
      this.setUiAuthModal({ isVisible: false })
    }
  }
}
</script>
